/**
 * web-portal localization interface
 *
 */

let currentLocale: SupportedLocales | undefined;

const LOCALES = [
  'en',
  'de',
  'nl',
  'en-US',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-AR',
  'es-AR',
  'de-AT',
  'fr-CA',
  'nl-NL',
] as const;

export type SupportedLocales = typeof LOCALES[number];

const supported = LOCALES.reduce((ret, value) => {
  const [locale , country] = value.split('-');

  ret[value] = [locale, (country ?? locale).toUpperCase()].join('');

  return ret;
}, {} as Record<SupportedLocales, string>);

export function setCurrentLocale(locale?: SupportedLocales) {
  currentLocale = locale;
}

export function getCurrentLocale(): SupportedLocales | undefined {
  return currentLocale;
}

export function getSupportedLocales() {
  return supported;
}
